import { EntityState } from '@ngrx/entity';
import { Template } from '@modules/template/student/models/template';
import { ClassroomCourse, ClassroomCourseFilter } from '@modules/course/classroom/models';

export const templateFeatureKey = 'templates';

export interface TemplateState extends EntityState<Template> {
  selectedId: string;
  classrooms: ClassroomCourse[];
  classroomFilter: ClassroomCourseFilter;
  error: any;
  totalCount: number;
  filter: any;
}
